import React, { useEffect, useState } from 'react';
import { Paper, Button, Table, TableBody, TableRow, TableCell, TableHead, Checkbox, TableSortLabel, Grid } from '@mui/material';
import { LeasesMenuList, LeasesNav } from '../../../elements';
import { DeletePopUp, Pagination, STableLoader, PageLoader } from '../../../../shared_elements';
import ExceptionToAcceptanceList from '../components/ExceptionToAcceptanceList';
import ExceptionToAcceptanceCRU from '../components/ExceptionToAcceptanceCRU';
import NoRecordFound from '../../../../shared_elements/NoRecordFound';
import { globalDeleteService, globalGetService } from '../../../../utils/globalApiServices';
import { checkApiStatus } from '../../../../utils';
import { useParams } from 'react-router-dom';
import { deleteExceptionToAcceptanceApi, getExceptionToAcceptanceApi } from '../apiServices';
import { ButtonLoader, ShowAttachments } from '../../../../shared_elements/components';
import { enqueueSnackbar } from 'notistack';
import { PermissionWrapper } from '../../../../wrappers';
import { RoleBaseAccess } from "../../../../hoc";
import LeasesBasicDetails from '../../../elements/LeasesBasicDetails';
import { isMobile } from 'react-device-detect';
import { trackActivity } from '../../../../utils/mixpanel';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import { getStorage } from '../../../../shared_elements/actionCreators';
import { useDispatch, useSelector } from 'react-redux';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 238px)';

const ExceptionToAcceptanceHd = ({ sortInfo, createSortHandler, toggleBulkOps, bulk, item }) => {
  const tableSorting = (key, name, minWidth) => (
    <TableSortLabel sx={{ whiteSpace: 'nowrap' }} active={sortInfo?.sort_by === key} direction={sortInfo?.sort_by === key ? sortInfo.sort : 'asc'} onClick={() => createSortHandler(key)} >
      <span style={{ color: sortInfo?.sort_by === key ? '#496ac5' : 'inherit' }}>{name}</span>
    </TableSortLabel>
  );
  return (
    <TableRow>
      <TableCell className="table-actions-header">
        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "exceptions_to_acceptance", operationType: ['D'] }}>
          <Checkbox size='small' onChange={(e) => toggleBulkOps(e.target.checked, "bulk", item)}
            checked={item?.length === bulk?.ids?.length && item?.length > 0} /></PermissionWrapper>
        Action(s)
      </TableCell>
      <TableCell sx={{ minWidth: "150px", whiteSpace: 'nowrap' }}>{tableSorting("name", "Name")}</TableCell>
      <TableCell sx={{ minWidth: "150px", whiteSpace: 'nowrap' }}>{tableSorting("component", "Component")}</TableCell>
      <TableCell sx={{ minWidth: "150px", whiteSpace: 'nowrap' }}>{tableSorting("reference", "Reference")}</TableCell>
      <TableCell sx={{ minWidth: "150px", whiteSpace: 'nowrap' }}>{tableSorting("amount", "Amount")}</TableCell>
      <TableCell sx={{ minWidth: "90px" }}>{tableSorting("date", "Date")}</TableCell>
      <TableCell sx={{ minWidth: "150px" }}>{tableSorting("completion_date", "Completion Date")}</TableCell>
      <TableCell sx={{ minWidth: "90px" }}>{tableSorting("status", "Status")}</TableCell>
      <TableCell sx={{ minWidth: "120px" }}>{tableSorting("significant", "Significant")}</TableCell>
      <TableCell sx={{ minWidth: "120px" }}>{tableSorting("remarks", "Remarks")}</TableCell>
      <TableCell sx={{ minWidth: "120px" }}>{tableSorting("description", "Description")}</TableCell>
    </TableRow>
  );
};

const ExceptionToAcceptance = () => {
  const { leaseSlug } = useParams();
  const dispatch=useDispatch();
  const {fileUploadDetails} = useSelector((state) => state.leases);
  const params = { leaseSlug: leaseSlug };
  const [skeletonLoader, setSkeletonLoader] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [addEditExcepToAccep, setAddEditExcepToAccep] = useState({ mode: "", modal: false, data: null });
  const [deleteExcepToAccep, setDeleteExcepToAccep] = useState({ modal: false, data: null });
  const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
  const [exceptionToAcceptanceInfo, setExceptionToAcceptanceInfo] = useState({ list: [], pagination: null });
  const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
  const [uploadfile, setUploadfile] = useState({ mode: '', modal: false, data: null });
  const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' });
  const[isExport,seIsExport]=useState(false)
  const[uploadFileProgressData,setUploadFileProgressData]=useState({})
  const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
  const [slug,setSlug]=useState({})

  useEffect(() => {
    const uploadedFileData = getApiResponse("exceptions_to_acceptance", slug);
    getExceptionToAcceptanceList('skeletonLoader', {per_page:50});
    trackActivity('Page Viewed',{ page_title: 'Exception to Acceptance'})
    setUploadFileProgressData({uploadedFileData});
  }, []);

  const getExceptionToAcceptanceList = (loaderType, query = {}) => {
    loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
    globalGetService(getExceptionToAcceptanceApi(params, query), {}).then(response => {
      loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
      if (checkApiStatus(response)) {
        setExceptionToAcceptanceInfo(response?.data?.data)
      }
    });
     dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"exceptions_to_acceptance"}))
  }

  const createSortHandler = (key) => {
    let sortQuery = { sort_by: key };
    if (sortInfo.sort_by === key) {
      sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' };
    } else {
      sortQuery = { ...sortQuery, sort: 'asc' };
    }
    setSortInfo(sortQuery);
    getExceptionToAcceptanceList('fetch', { ...sortQuery, per_page: exceptionToAcceptanceInfo?.pagination?.per_page || 50 });
  };

  const onDeleteExceptionToAcceptance = () => {
    setLoading(true);
    const idsToDelete = deleteExcepToAccep?.modal && deleteExcepToAccep?.data?.id ? [deleteExcepToAccep?.data?.id] : (bulk?.ids || []).map(item => item?.id);
    globalDeleteService(deleteExceptionToAcceptanceApi(params), { ids: idsToDelete })
      .then(response => {
        setLoading(false);
        if (checkApiStatus(response)) {
          trackActivity('Item Deleted', { page_title: `Delete Amendment`, success_msg: response?.data?.message, item_ids: deleteExcepToAccep?.data || bulk?.ids, response: response?.data })
          setDeleteExcepToAccep({ modal: false, data: null });
          setBulk({ modal: false, ids: [], title: '', type: '' })
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          getExceptionToAcceptanceList("fetch", {per_page: exceptionToAcceptanceInfo?.pagination?.per_page || 50});
        }
        else {
          setLoading(false);
          enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Deleted', { page_title: `Delete Amendment`, error_msg: response?.data?.message, item_ids: deleteExcepToAccep?.data || bulk?.ids, response: response?.data })
        }
      })
  }

  const toggleBulkOps = async (flag, type, item) => {
    try {
      if (type === "bulk") {
        setBulk({ ...bulk, type: "bulk", ids: flag ? item : [] });
      } else {
        setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
      }
    } catch (error) {
      console.error("Error fetching Data!", error);
    }
  }

  const handelAttchments = (attachslug) => {
    setUploadfile({
      ...uploadfile, data: { ...uploadfile.data, attachments: uploadfile.data.attachments.filter(item => item.slug !== attachslug) }
    });
    getExceptionToAcceptanceList("", {per_page: exceptionToAcceptanceInfo?.pagination?.per_page || 50});
  }

  const handleExport=()=>{
    let query={ export: true }
      if (sortInfo?.sort && sortInfo?.sort_by) {
        query = { ...query, sort: sortInfo.sort, sort_by: sortInfo.sort_by }
      }
    seIsExport(true);
    globalGetService(getExceptionToAcceptanceApi(params ,query)).then((response)=>{
        if (checkApiStatus(response)){
          enqueueSnackbar(
                 response?.data.message,
                 { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
               );
                seIsExport(false);
        }
    })
  }
  const handleItemClicked = (page_type) => {
    trackActivity('Item Clicked', { page_title: `Exception to Acceptance`, page_type: page_type, })
  }
   
  const handleUpload = async (slug, mode) => {
        setSlug({slug:slug})

        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "exceptions_to_acceptance",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments,response }) => {
                setUploadFileProgressData({ progressRefs, attachments ,response});
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }});
                getExceptionToAcceptanceList("", { per_page: exceptionToAcceptanceInfo?.pagination?.per_page || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }});
            }
        });
       setSlug({})
  };



  return (
    <>
    <LeasesBasicDetails/>
    <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
      <LeasesNav type="terms"/>
      <div className='lease-details-content contnet-overflow'>
            <Paper square className="responsive-paper">
              <Grid container className="responsive-grid" alignItems="end">
                <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                  <LeasesMenuList btnText="Exception To Acceptance" type="terms"/>
                </Grid>
              <Grid item size={{ md: 6, xs: 12 }} className="menu-container">
                <BackToLeaseList />
              </Grid>
              <Grid item size={{ md: 6, xs: 12 }}>
                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '0px', float: 'right' }}>
                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} })}/> </li>
                    {
                      bulk?.type && bulk?.ids?.length ?
                        <>
                          <li className='lease-mobile-button'>
                          <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary">Cancel</Button>
                          </li>
                          <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "exceptions_to_acceptance", operationType: ['D'] }}>
                            <li className='lease-mobile-button'>
                            <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057", }}>{`Delete (${bulk?.ids?.length})`}</Button>
                            </li>
                          </PermissionWrapper>
                        </> : null
                    }
                  {exceptionToAcceptanceInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary'> Export </Button> </li> : null}
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "exceptions_to_acceptance", operationType: ['C'] }}>
                      <li className='lease-mobile-button'>
                        <Button color="primary" startIcon={<AddOutlinedIcon />} variant='contained' size='small' onClick={() => { setAddEditExcepToAccep({ modal: true, mode: "add", data: { name: "", description: "" } }); handleItemClicked('Add Item Button') }}> Add Exception To Acceptance </Button>
                      </li>
                    </PermissionWrapper>
                  </ul>
                </Grid>
              </Grid>
            </Paper>
        <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: exceptionToAcceptanceInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
          <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
            {skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
                <Table className='mui-table-format' stickyHeader>
                  <TableHead>
                    <ExceptionToAcceptanceHd sortInfo={sortInfo} createSortHandler={createSortHandler} item={exceptionToAcceptanceInfo?.list}
                      toggleBulkOps={toggleBulkOps}
                      bulk={bulk} />
                  </TableHead>
                  <TableBody>
                    {
                      exceptionToAcceptanceInfo?.list?.length > 0 && exceptionToAcceptanceInfo.list.map((item, index) => {
                           const uploadedFileData = getApiResponse("exceptions_to_acceptance", item?.slug);

                        return (
                          <ExceptionToAcceptanceList
                            slug={slug?.slug}
                            uploadedFileData={uploadedFileData }
                            uploadFileProgressData={uploadFileProgressData}
                            viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                            key={index}
                            item={item}
                            viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                            onDelete={() => {
                              setDeleteExcepToAccep({ modal: true, data: item });
                              setBulk({ modal: false, ids: [item], title: '', type: '' });
                            }}
                            onEdit={() => setAddEditExcepToAccep({ modal: true, mode: 'edit', data: item, })}
                            onView={() => setAddEditExcepToAccep({ modal: true, mode: 'view', data: item })}
                            toggleBulkOps={toggleBulkOps}
                            bulk={bulk}
                            viewFile={() => setUploadfile({ modal: true, mode: 'file', data: item })}
                          />
                        )
                    })
                    }
                  </TableBody>
                </Table>
            )}
          </div>
          <Paper square>
            {!skeletonLoader && !exceptionToAcceptanceInfo?.list?.length && <NoRecordFound />}
            <Pagination
              pagination={exceptionToAcceptanceInfo?.pagination}
              onPageChange={(event, newPage) => { const pageNum = newPage + 1; getExceptionToAcceptanceList("Pageloader", { page: pageNum, per_page: exceptionToAcceptanceInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}) }); }}
              onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getExceptionToAcceptanceList("Pageloader", { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}) }); }}
            />
          </Paper>
        </Paper>
      </div>
    </Paper>

      {
        addEditExcepToAccep?.modal ?
          <ExceptionToAcceptanceCRU
          fileUpload={handleUpload}
            addEditExcepToAccep={addEditExcepToAccep}
            params={params}
            modeType={addEditExcepToAccep?.mode}
            getExceptionToAcceptanceList={getExceptionToAcceptanceList}
            onOpenAttachments={() => setUploadfile({ modal: true, data: addEditExcepToAccep?.data, mode:'view' })}
            getResponseBack={() => {getExceptionToAcceptanceList('pageLoader', {
              page: exceptionToAcceptanceInfo?.pagination?.page || 1,
              per_page: exceptionToAcceptanceInfo?.pagination?.per_page || 10
            }); setBulk({modal: false, ids: [], type: '', title: ''})}}
            onToggleModal={() => setAddEditExcepToAccep({ ...addEditExcepToAccep, modal: false, data: null })}
          /> : null
      }
      {
        deleteExcepToAccep?.modal ?
          <DeletePopUp
            modal={deleteExcepToAccep.modal}
            title="Delete Exception To Acceptance"
            content={`Are you sure, you want to Delete?`}
            onToggleModal={() => {
              setDeleteExcepToAccep({ modal: false, data: null });
              setBulk({ modal: false, ids: [], title: '', type: '' });
            }}
            onDeleteRecords={() => onDeleteExceptionToAcceptance()} /> : null
      }
      {
        bulk.modal ? <DeletePopUp
          modal={bulk.modal}
          title={`Delete ${bulk?.ids?.length === (exceptionToAcceptanceInfo?.list?.length || 0) ? 'All Exception To Acceptance' : 'Selected Exception To Acceptance'}`}
          content={`Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?`}
          onToggleModal={() => setBulk({ modal: false, ids: [], title: '', type: '' })}
          onDeleteRecords={() => onDeleteExceptionToAcceptance()}
        /> : null
      }
      {
        uploadfile.modal ?
          <ShowAttachments
            url="delete-attachment"
            moduleName="Exception To Acceptance"
            attachmentsData={uploadfile}
            getResponseBack={handelAttchments}
            toggleModalFn={() => setUploadfile({ modal: false, data: null, mode:'' })}
            permissionKey='exceptions_to_acceptance'
            onViewDisabled={addEditExcepToAccep?.mode === 'view' || uploadfile?.mode==='view'}
          /> : null
      }
      {
          revisionHistory.modal &&  
          <RevisionHistory 
           moduleName={"exceptions_to_acceptance"}
           revisionHistory={revisionHistory}
           onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
          />
        }
         <FileUploadLayout
               uploadFileStatus={uploadFileStatus}
               open={uploadFileStatus?.modal}
               setUploadFileStatus={setUploadFileStatus}
               uploadFileProgressData={uploadFileProgressData}
               progressRefs={uploadFileProgressData?.progressRefs}
               attachments={uploadFileProgressData?.attachments}
               onDownloadComplete={()=> setSlug({})}
          />
      {isLoading ? <PageLoader /> : null}
     </>
  )
}

export default RoleBaseAccess(ExceptionToAcceptance, { application: 'lease_revamp', feature: 'exceptions_to_acceptance', operationType: ['R'], leaseNav: true });
